var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[_c('weather-today'),_c('weather-every-hour'),_c('weather-week'),_c('amedas-observed'),_c('div',{staticClass:"ad-banner-floating-other"},[_c('ad-banner')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }